import { render, staticRenderFns } from "./TodoTaskHandlerSidebar.vue?vue&type=template&id=2199a9ba&scoped=true&"
import script from "./TodoTaskHandlerSidebar.vue?vue&type=script&lang=js&"
export * from "./TodoTaskHandlerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TodoTaskHandlerSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TodoTaskHandlerSidebar.vue?vue&type=style&index=1&id=2199a9ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2199a9ba",
  null
  
)

export default component.exports